import { FC } from 'react';
import { useFacebookAnalytics } from './useFacebookAnalytics';

export const OrderSuccessEvent: FC = () => {
  useFacebookAnalytics('OrderSuccess', true);
  return null;
};
